"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignedPatientsMapper = void 0;
exports.chatsMapper = chatsMapper;
exports.servicesToPatientMapper = servicesToPatientMapper;
exports.chatMapper = chatMapper;
exports.groupChatsMapper = groupChatsMapper;
exports.groupChatMapper = groupChatMapper;
exports.pendingReferralMapper = pendingReferralMapper;
exports.groupInfoMapper = groupInfoMapper;
exports.partialGroupInfoMapper = partialGroupInfoMapper;
exports.groupInfoMediaListMapper = groupInfoMediaListMapper;
exports.groupInfoMembersMapper = groupInfoMembersMapper;
exports.broadcastInfoMembersMapper = broadcastInfoMembersMapper;
exports.privateChatsMapper = privateChatsMapper;
exports.broadcastChatsMapper = broadcastChatsMapper;
exports.privateChatMapper = privateChatMapper;
exports.broadcastChatMapper = broadcastChatMapper;
exports.broadcastInfoMapper = broadcastInfoMapper;
exports.nonPatientChatGroupsMapper = nonPatientChatGroupsMapper;
exports.nonPatientGroupDataMapper = nonPatientGroupDataMapper;
exports.recentContactsMapper = recentContactsMapper;
exports.scheduledVisitsMapper = scheduledVisitsMapper;
const Message_1 = __importDefault(require("../message/Message"));
const models_1 = require("../models");
const utils_1 = require("../utils");
const MapperUtils_1 = require("./MapperUtils");
const MessagesMapper_1 = require("./MessagesMapper");
const UserInfoMapper_1 = require("./UserInfoMapper");
const LabRequisitionsMapper_1 = require("./LabRequisitionsMapper");
function chatsMapper(chatsResponse) {
    return Object.assign({ unreadChatCount: chatsResponse.unreadChatCount, totalUnreadChatCount: chatsResponse.totalUnreadChatCount, searchMatchCount: chatsResponse.searchMatchCount }, (0, MapperUtils_1.paginationMapper)(chatsResponse));
}
function servicesToPatientMapper(servicesToPatient) {
    return servicesToPatient.map(serviceToPatient => ({
        id: serviceToPatient.id,
        name: serviceToPatient.name,
        shorthand: models_1.CLINICIAN_ROLES[serviceToPatient.shorthand],
        status: serviceToPatient.status.toString(),
    }));
}
function chatMapper(chat) {
    return {
        id: chat.from,
        from: chat.from,
        user: chat.user,
        action: chat.action,
        status: models_1.CHAT_STATUS[chat.status],
        updatedAt: chat.updatedAt,
        createdAt: chat.createdAt,
        chatType: models_1.CHAT_TYPE[chat.chatType],
        unreadCount: chat.unreadCount,
        lastMessage: chat.lastMessage,
        chatLogId: chat._id,
    };
}
function groupChatsMapper(chatsResponse, userDirectory, organizationUser, httpAdapter) {
    const mappedChats = [];
    for (const chat of chatsResponse.data) {
        mappedChats.push(groupChatMapper(chat, userDirectory, organizationUser, httpAdapter));
    }
    return Object.assign(Object.assign({}, chatsMapper(chatsResponse)), { chats: mappedChats });
}
function groupChatMapper(chat, userDirectory, organizationUser, httpAdapter) {
    const groupInfo = groupInfoMapper(chat.groupInfo, userDirectory, organizationUser, httpAdapter);
    return Object.assign(Object.assign({}, chatMapper(chat)), { lastMessageRead: chat.lastMessageRead, isMember: chat.isMember, hasPriorityMessage: chat.hasPriorityMessage, hasAcknowledgeMessage: chat.hasAcknowledgeMessage, groupType: models_1.GROUP_TYPE[chat.groupType], groupInfo });
}
function pendingReferralMapper(pendingReferralResponse) {
    return pendingReferralResponse.map((pendingReferral) => {
        var _a;
        return {
            userId: (_a = pendingReferral.id) !== null && _a !== void 0 ? _a : "",
            createdAt: pendingReferral.createdAt,
            message: pendingReferral.referralMessage,
        };
    });
}
function groupInfoMapper(groupInfo, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (groupInfo.lupa && { lupa: groupInfo.lupa })), (groupInfo.actualVisitCount && {
        actualVisitCount: groupInfo.actualVisitCount && lupaMapper(groupInfo.actualVisitCount),
    })), (groupInfo.socStarter && {
        socStarter: groupInfo.socStarter && socStaterMapper(groupInfo.socStarter),
    })), (groupInfo.name && { name: groupInfo.name })), (groupInfo.mrn && { mrn: groupInfo.mrn })), (groupInfo.servicesToPatient && {
        servicesToPatient: groupInfo.servicesToPatient.length > 0
            ? servicesToPatientMapper(groupInfo.servicesToPatient)
            : [],
    })), (groupInfo.patientStatus && { patientStatus: groupInfo.patientStatus })), (groupInfo._id && { id: groupInfo._id })), (groupInfo.status && {
        status: models_1.CHAT_STATUS[groupInfo.status],
    })), (groupInfo.organizationId && {
        organizationId: groupInfo.organizationId,
    })), (groupInfo.members && {
        members: groupInfo.members && groupInfoMembersMapper(groupInfo.members),
    })), (groupInfo.patientInfo && {
        patientInfo: patientInfoMapper(groupInfo.patientInfo),
    })), (groupInfo.email && { email: groupInfo.email })), (groupInfo.insurance && { insurance: groupInfo.insurance })), (groupInfo.patientCareTime && {
        patientCareTime: groupInfo.patientCareTime,
    })), (groupInfo.referralSource && {
        referralSource: groupInfo.referralSource,
    })), (groupInfo.communityLiaisoning && {
        communityLiaisoning: groupInfo.communityLiaisoning,
    })), (groupInfo.about && { about: groupInfo.about })), (groupInfo.info && { info: groupInfo.info })), (groupInfo.image && { image: groupInfo.image })), (groupInfo.type && {
        groupType: models_1.GROUP_TYPE[groupInfo.type],
        chatType: groupTypeToChatType(models_1.GROUP_TYPE[groupInfo.type]),
    })), (groupInfo.media && {
        mediaList: socketAdapter &&
            groupInfoMediaListMapper(groupInfo.media.data, userDirectory, organizationUser, httpAdapter, socketAdapter),
    })), (groupInfo.meta && { meta: groupInfo.meta })), (groupInfo.socScheduledOn && {
        socScheduledOn: groupInfo.socScheduledOn,
    })), (groupInfo.pendingReferrals && Object.assign({}, (groupInfo.pendingReferrals && {
        pendingReferrals: pendingReferralMapper(groupInfo.pendingReferrals),
    })))), (groupInfo.members && {
        isMember: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.members) && (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.members.length) > 0
            ? getIsMember(groupInfo.members, userDirectory.currentUserProfile.id)
            : false,
    })), (groupInfo.attachments && {
        attachments: groupInfo.attachments && attachmentMapper(groupInfo.attachments),
    })), (groupInfo.settings && { settings: settingsMapper(groupInfo.settings) })), (groupInfo.rpmDevices && {
        rpmDevices: rpmDeviceMappers(groupInfo.rpmDevices),
    })), (groupInfo.labRequisitions && {
        labRequisitions: (0, LabRequisitionsMapper_1.labRequisitionsMapper)(groupInfo.labRequisitions),
    })), (groupInfo.createdAt && { createdAt: groupInfo.createdAt })), (groupInfo.timeline && { timeline: groupInfo.timeline }));
}
function groupTypeToChatType(groupType) {
    if (groupType === models_1.GROUP_TYPE.BROADCAST) {
        return models_1.CHAT_TYPE.BROADCAST;
    }
    if (groupType === models_1.GROUP_TYPE.PATIENT ||
        groupType === models_1.GROUP_TYPE.NON_PATIENT ||
        groupType === models_1.GROUP_TYPE.HIDDEN) {
        return models_1.CHAT_TYPE.GROUP;
    }
    return models_1.CHAT_TYPE.PRIVATE;
}
function partialGroupInfoMapper(groupInfo, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    const groupType = models_1.GROUP_TYPE[groupInfo.type];
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ lupa: groupInfo.lupa && lupaMapper(groupInfo.lupa), socStarter: groupInfo.socStarter && socStaterMapper(groupInfo.socStarter), name: groupInfo.name, mrn: groupInfo.mrn, servicesToPatient: groupInfo.servicesToPatient &&
            (groupInfo.servicesToPatient.length > 0
                ? servicesToPatientMapper(groupInfo.servicesToPatient)
                : []), patientStatus: groupInfo.patientStatus, id: groupInfo._id, status: groupInfo.status, organizationId: groupInfo.organizationId, members: groupInfo.members && groupInfoMembersMapper(groupInfo.members) }, (groupInfo.patientInfo && {
        patientInfo: patientInfoMapper(groupInfo.patientInfo),
    })), { email: groupInfo.email, insurance: groupInfo.insurance, patientCareTime: groupInfo.patientCareTime, referralSource: groupInfo.referralSource, communityLiaisoning: groupInfo.communityLiaisoning, about: groupInfo.about, info: groupInfo.info, image: groupInfo.image, groupType, mediaList: groupInfo.media &&
            socketAdapter &&
            groupInfoMediaListMapper(groupInfo.media.data, userDirectory, organizationUser, httpAdapter, socketAdapter), meta: groupInfo.meta, socScheduledOn: groupInfo.socScheduledOn }), (groupInfo.pendingReferrals && {
        pendingReferrals: pendingReferralMapper(groupInfo.pendingReferrals),
    })), { isMember: (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.members) &&
            (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.members.length) > 0 &&
            getIsMember(groupInfo.members, userDirectory.currentUserProfile.id), attachments: groupInfo.attachments && attachmentMapper(groupInfo.attachments) }), (groupInfo.settings && { settings: settingsMapper(groupInfo.settings) }));
}
function patientInfoMapper(patientInfo) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        address: patientInfo.address
            ? {
                geoLocation: {
                    coordinates: (_b = (_a = patientInfo.address.geoLocation) === null || _a === void 0 ? void 0 : _a.coordinates) !== null && _b !== void 0 ? _b : [],
                    type: (_d = (_c = patientInfo.address.geoLocation) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : "",
                },
                lat: (_e = patientInfo.address.lat) !== null && _e !== void 0 ? _e : 0,
                lng: (_f = patientInfo.address.lng) !== null && _f !== void 0 ? _f : 0,
                placeName: (_g = patientInfo.address.placeName) !== null && _g !== void 0 ? _g : "",
                apartmentNo: (_h = patientInfo.address.apartmentNo) !== null && _h !== void 0 ? _h : "",
            }
            : undefined,
        countryCode: patientInfo.countryCode,
        dob: patientInfo.dob,
        firstName: patientInfo.firstName,
        lastName: patientInfo.lastName,
        name: patientInfo.name,
        phoneNo: patientInfo.phoneNo,
        age: (0, utils_1.getAgeFromDob)(patientInfo.dob),
    };
}
function attachmentMapper(attachments) {
    return attachments.map((attachment) => {
        return Object.assign({ id: attachment._id, media: new Array(Object.assign({ url: attachment.url }, (attachment.text && { caption: attachment.text }))), mediaType: attachment.type === "DOCUMENT"
                ? models_1.MESSAGE_CONTENT_TYPE.DOCUMENT
                : models_1.MESSAGE_CONTENT_TYPE.IMAGE, type: getAttachmentType(attachment.attachmentType) }, (attachment.size && { size: attachment.size }));
    });
}
function getAttachmentType(type) {
    switch (type) {
        case "DOC":
            return models_1.ATTACHMENT_TYPE.DOC;
        case "XLS":
            return models_1.ATTACHMENT_TYPE.XLS;
        case "PDF":
            return models_1.ATTACHMENT_TYPE.PDF;
        default:
            return models_1.ATTACHMENT_TYPE.JPG;
    }
}
function getIsMember(members, currentUserId) {
    const isMember = members.find(member => {
        // add broadcast members response
        if (typeof member === "string") {
            return member === currentUserId;
        }
        // broadcast group members
        if ("_id" in member && member._id === currentUserId) {
            return true;
        }
        // group members
        if ("user" in member && member.user === currentUserId) {
            return true;
        }
        return false;
    });
    return !!isMember;
}
function socStaterMapper(socStarterData) {
    return {
        SN: socStarterData.SN,
        PT: socStarterData.PT,
        SLP: socStarterData.SLP,
        OT: socStarterData.OT,
    };
}
function lupaMapper(lupaData) {
    return {
        firstSession: lupaData.firstSession,
        secondSession: lupaData.secondSession,
    };
}
function groupInfoMediaListMapper(mediaResponseList, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    const mediaMessageList = [];
    for (const mediaMessage of mediaResponseList) {
        const finalMessage = (0, MessagesMapper_1.messageMapper)(mediaMessage, userDirectory, organizationUser.getOrganization());
        if (finalMessage) {
            const message = new Message_1.default(finalMessage, socketAdapter, httpAdapter, userDirectory, organizationUser);
            mediaMessageList.push(message);
        }
    }
    return mediaMessageList;
}
function groupInfoMembersMapper(members) {
    const mappedMembers = [];
    for (const member of members) {
        mappedMembers.push({
            userId: member.user,
            settings: member.settings,
            hidden: member.hidden,
        });
    }
    return mappedMembers;
}
function broadcastInfoMembersMapper(members) {
    const mappedMembers = [];
    for (const member of members) {
        if ("user" in member) {
            mappedMembers.push({ userId: member.user });
        }
        else if ("_id" in member) {
            mappedMembers.push({ userId: member._id });
        }
    }
    return mappedMembers;
}
function privateChatsMapper(chatsResponse) {
    return Object.assign(Object.assign({}, chatsMapper(chatsResponse)), { chats: chatsResponse.data.map((chat) => privateChatMapper(chat)) });
}
function broadcastChatsMapper(chatsResponse, userDirectory, organizationUser, httpAdapter) {
    const mappedChats = [];
    for (const chat of chatsResponse.data) {
        mappedChats.push(broadcastChatMapper(chat, userDirectory, organizationUser, httpAdapter));
    }
    return Object.assign(Object.assign({}, chatsMapper(chatsResponse)), { chats: mappedChats });
}
function privateChatMapper(chat) {
    return Object.assign(Object.assign({}, chatMapper(chat)), { lastMessageRead: chat.lastMessageRead, userInfo: chat.info && (0, UserInfoMapper_1.userInfoMapper)(chat.info), lastMessage: chat.lastMessage, hasPriorityMessage: chat.hasPriorityMessage });
}
function broadcastChatMapper(chat, userDirectory, organizationUser, httpAdapter) {
    return Object.assign(Object.assign({}, chatMapper(chat)), { broadcastInfo: broadcastInfoMapper(chat.broadcastInfo, userDirectory, organizationUser, httpAdapter), isMember: chat.isMember });
}
function broadcastInfoMapper(broadcastInfoResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    const groupType = models_1.GROUP_TYPE.BROADCAST;
    return Object.assign(Object.assign(Object.assign(Object.assign({ id: broadcastInfoResponse._id, status: models_1.GROUP_STATUS[broadcastInfoResponse.status], groupType, isSystemGenerated: broadcastInfoResponse.isSystemGenerated, name: broadcastInfoResponse.name }, (broadcastInfoResponse.about && { about: broadcastInfoResponse.about })), (broadcastInfoResponse.media && {
        mediaList: broadcastInfoResponse.media &&
            socketAdapter &&
            groupInfoMediaListMapper(broadcastInfoResponse.media.data, userDirectory, organizationUser, httpAdapter, socketAdapter),
    })), (broadcastInfoResponse.members && {
        members: broadcastInfoMembersMapper(broadcastInfoResponse.members),
    })), { createdBy: broadcastInfoResponse.createdBy, isMember: (broadcastInfoResponse === null || broadcastInfoResponse === void 0 ? void 0 : broadcastInfoResponse.members) &&
            (broadcastInfoResponse === null || broadcastInfoResponse === void 0 ? void 0 : broadcastInfoResponse.members.length) > 0
            ? getIsMember(broadcastInfoResponse === null || broadcastInfoResponse === void 0 ? void 0 : broadcastInfoResponse.members, userDirectory.currentUserProfile.id)
            : false, organizationId: broadcastInfoResponse.organizationId });
}
function nonPatientChatGroupsMapper(groups) {
    return {
        data: groups.data.map((dataItem) => {
            return nonPatientGroupDataMapper(dataItem);
        }),
        page: groups.page,
        limit: groups.limit,
        total: groups.total,
    };
}
function nonPatientGroupDataMapper(data) {
    return {
        id: data._id,
        image: data.image,
        name: data.name,
        status: models_1.PATIENT_STATUS.ACTIVE,
        type: models_1.GROUP_TYPE.NON_PATIENT,
    };
}
function settingsMapper(data) {
    var _a;
    return {
        canSendToPatient: data.canSendToPatient,
        canSendToPhysician: data.canSendToPhysician,
        hidden: data.hidden,
        mute: { value: (_a = data.mute) === null || _a === void 0 ? void 0 : _a.value },
        visibleToPatient: data.visibleToPatient,
        visibleToPhysician: data.visibleToPhysician,
    };
}
function rpmDeviceMappers(data) {
    return data.map((item) => rpmDeviceMapper(item));
}
function rpmDeviceMapper(data) {
    return Object.assign(Object.assign({}, ((data === null || data === void 0 ? void 0 : data.rpmDeviceId) && { rpmDeviceId: data === null || data === void 0 ? void 0 : data.rpmDeviceId })), { rpmDeviceType: models_1.RPM_DEVICE_TYPE[data.rpmDeviceType], status: models_1.RPM_DEVICE_STATUS[data.status] });
}
function recentContactsMapper(recentContactsResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    return __awaiter(this, void 0, void 0, function* () {
        const otherContacts = recentContactsResponse.otherContacts.map((user) => (0, UserInfoMapper_1.userInfoMapper)(user));
        const recentChats = yield Promise.all(recentContactsResponse.recentChats.map((groupInfo) => groupInfoMapper(groupInfo, userDirectory, organizationUser, httpAdapter, socketAdapter)));
        return {
            total: recentContactsResponse.total,
            pageNo: recentContactsResponse.pageNo,
            limit: recentContactsResponse.limit,
            data: [...recentChats, ...otherContacts],
        };
    });
}
function scheduledVisitsMapper(scheduledVisitsResponse) {
    return scheduledVisitsResponse.map((scheduledVisit) => {
        const { userId } = scheduledVisit;
        return Object.assign(Object.assign({ id: scheduledVisit._id, chatId: scheduledVisit.chatId, chatType: models_1.CHAT_TYPE[scheduledVisit.chatType], userId, type: models_1.SCHEDULE_TYPE[scheduledVisit.type], isTeleVisit: scheduledVisit.isTeleVisit, schedulerTime: scheduledVisit.schedulerTime, schedulerEndTime: scheduledVisit.schedulerEndTime, schedulerDate: scheduledVisit.schedulerDate, message: scheduledVisit.message, title: scheduledVisit.title, status: models_1.SCHEDULE_STATUS[scheduledVisit.status], createdAt: scheduledVisit.createdAt, name: scheduledVisit.name, groupType: models_1.GROUP_TYPE[scheduledVisit.groupType], patientStatus: scheduledVisit.patientStatus }, (scheduledVisit.location && { location: scheduledVisit.location })), (scheduledVisit.image && { image: scheduledVisit.image }));
    });
}
const assignedPatientsMapper = (assignedPatientsResponse) => {
    return assignedPatientsResponse.map(group => ({
        patientStatus: String(group.patientStatus),
        patients: group.patients.map(patient => ({
            id: patient._id,
            uuid: patient.uuid,
            type: patient.type,
            name: patient.name,
            about: patient.about,
            meta: patient.meta,
            servicesToPatient: patient.servicesToPatient &&
                (patient.servicesToPatient.length > 0
                    ? servicesToPatientMapper(patient.servicesToPatient)
                    : []),
            status: patient.status,
            patientStatus: String(patient.patientStatus),
        })),
    }));
};
exports.assignedPatientsMapper = assignedPatientsMapper;
